import { UITexts } from '../../types/ui';

export const uiTexts: UITexts = {
  language: {
    name: "Russian",
    nativeName: "Русский",
    code: "ru",
    flag: "🌐" // Нейтральный флаг вместо 🇷🇺
  },

  common: {
    loading: "Секундочку...",
    error: "Упс, что-то пошло не так",
    retry: "Попробовать ещё раз",
    back: "Назад",
    next: "Дальше",
    previous: "Назад",
    finish: "Готово",
    start: "Поехали!",
    restart: "Заново",
    continue: "Продолжаем",
    cancel: "Отменить",
    close: "Закрыть",
    ok: "Понятно",
    yes: "Да",
    no: "Нет",
    save: "Сохранить",
    share: "Поделиться",
    copy: "Скопировать",
    copied: "Скопировано!",
    minutes: "минут",
    seconds: "секунд",
    question: "вопрос",
    questions: "вопросов",
    answer: "ответ",
    answers: "ответов",
    correct: "Верно",
    incorrect: "Неверно",
    score: "Результат",
    time: "Время",
    difficulty: {
      easy: "Легко",
      medium: "Средне",
      hard: "Сложно",
      // ISTQB Knowledge levels
      k1: "K1",
      k2: "K2",
      k3: "K3",
      k4: "K4"
    }
  },

  demo: {
    title: "AI-тестер",
    subtitle: "Демо версия",
    description: "Готовы к зарплате AI-тестировщика? Узнайте за 15 минут",
    startButton: "Начать демо",
    badge: "БЕСПЛАТНОЕ ДЕМО",
    features: {
      title: "Что вас ждёт в полной версии",
      items: [
        "300+ экспертных вопросов",
        "11 полных глав программы",
        "40-минутная симуляция экзамена",
        "Подробные объяснения ответов",
        "Аналитика результатов и оценки",
        "Множественные сессии практики",
        "Мгновенный и пожизненный доступ",
        "Мобильный формат",
        "Бонус: Ранний доступ к продвинутому курсу по AI-тестированию"
      ],
      smartQuestions: {
        title: "Продвинутые вопросы",
        description: "Реальные сценарии из практики AI-тестирования"
      },
      instantFeedback: {
        title: "Мгновенная обратная связь",
        description: "Персонализированные объяснения от практика с 10+ летним опытом"
      },
      previewPower: {
        title: "Симуляция реальной сертификации",
        description: "Почувствуйте, каково это — сдавать настоящую сертификацию"
      }
    },
    comparison: {
      demo: {
        title: "ДЕМО",
        features: [
          "12 отобранных вопросов",
          "2 ключевые темы",
          "15 минут времени",
          "Результат сразу"
        ]
      },
      full: {
        title: "ПОЛНАЯ ВЕРСИЯ",
        features: [
          "300+ экспертных вопросов",
          "Все 11 глав программы",
          "40 минут как на настоящем экзамене",
          "Подробная аналитика",
          "Отслеживание прогресса"
        ],
        button: "Получить полный доступ"
      }
    },
    community: "Присоединяйтесь к AI-сообществу профессионалов, раскрывающих секреты тестирования AI",
    trustIndicators: "Создано на основе официальных материалов ISTQB",
    perfectFor: {
      title: "Идеально подходит для",
      items: [
        "QA-инженеров, переходящих на AI-тестирование",
        "Тестировщиков ПО, расширяющих свои навыки",
        "IT-специалистов, стремящихся к сертификации ISTQB",
        "Всех, кто готовится к собеседованиям по AI-тестированию",
        "Команд, повышающих квалификацию в области качества AI",
        "IT-профессионалов, развивающих карьеру"
      ]
    }
  },

  // Access Page
  access: {
    title: "Вход в полную версию",
    subtitle: "Введите код доступа",
    description: "Получите неограниченный доступ к 300+ экспертным вопросам по ИИ-тестированию и полноценной подготовке к экзамену.",
    form: {
      title: "Введите код доступа",
      placeholder: "Ваш код доступа...",
      button: "Открыть полную версию",
      submitting: "Проверяем..."
    },
    errors: {
      invalid: "Хм, код не подходит. Проверьте и попробуйте ещё раз.",
      empty: "Введите, пожалуйста, код доступа.",
      generic: "Что-то сломалось. Попробуйте ещё раз."
    },
    success: {
      title: "Добро пожаловать! 🎉",
      description: "Теперь у вас есть неограниченный доступ к полной версии ISTQB AI Tester!",
      validDays: "Ваш доступ действует постоянно",
      continueButton: "К полной версии"
    },
    purchase: {
      title: "Нет кода доступа?",
      subtitle: "Получите доступ прямо сейчас",
      description: "Купите полную версию квиза ISTQB AI Tester с 300+ вопросами, подробными объяснениями и полным покрытием программы.",
      features: [
        "300+ экспертных вопросов",
        "Все 11 глав программы",
        "Подробные объяснения",
        "Аналитика результатов",
        "Работает на телефоне",
        "Доступ навсегда"
      ],
      button: "Купить полную версию",
      note: "Скачивание сразу после покупки"
    },
    security: {
      note: "Коды доступа надёжно зашифрованы и защищены",
      expiry: "Неограниченный доступ"
    }
  },

  full: {
    title: "Обучение AI Tester",
    subtitle: "AI Tester Квиз",
    description: "Освойте все 11 глав программы ISTQB AI Testing",
    features: [
      "300+ экспертных вопросов",
      "Все 11 глав",
      "40 минут как на настоящем экзамене"
    ],
    welcome: {
      keyFeatures: {
        title: "Главные фишки",
        expertQuestions: {
          title: "300+ вопросов",
          features: [
            "Вся программа полностью",
            "Как на настоящем экзамене",
            "Разные уровни сложности"
          ]
        },
        adaptiveSystem: {
          title: "Умная система",
          features: [
            "Подстраивается под вас",
            "Выбирает подходящие вопросы",
            "Следит за прогрессом"
          ]
        },
        detailedAnalytics: {
          title: "Подробная аналитика",
          features: [
            "Анализ ваших результатов",
            "Находит слабые места",
            "Подсказывает, что изучать"
          ]
        }
      },
      whatMakesDifferent: {
        title: "Чем это круто?",
        expertCreated: {
          title: "Сделано экспертами",
          description: "Вопросы создавали практики AI-тестирования, которые знают всё о теории и практике"
        },
        completeCoverage: {
          title: "Полное покрытие",
          description: "Все 11 глав программы ISTQB AI Tester разобраны по косточкам"
        },
        realScenarios: {
          title: "Реальные ситуации",
          description: "Практические кейсы, с которыми вы точно столкнётесь в работе AI-тестировщика"
        },
        trackProgress: {
          title: "Отслеживание прогресса",
          description: "Детальная аналитика покажет ваши сильные и слабые стороны"
        }
      },
      perfectFor: {
        title: "Идеально подходит",
        items: [
          "QA-инженерам, которые хотят перейти в AI-тестирование",
          "Тестировщикам, расширяющим свой арсенал навыков",
          "IT-специалистам, нацеленным на ISTQB-сертификацию",
          "Всем, кто готовится к собеседованиям по AI-тестированию",
          "Командам, прокачивающим экспертизу в области AI",
          "IT-профессионалам, строящим карьеру"
        ]
      },
      startButton: "Начать путь к сертификации",
      trustIndicators: [
        "Проверено тысячами кандидатов по всему миру"
      ]
    }
  },

  quiz: {
    header: {
      title: "AI Tester Квиз",
      timeLeft: "Времени осталось",
      progress: "Прогресс",
      streak: "Серия"
    },
    navigation: {
      previous: "Назад",
      next: "Дальше",
      finish: "Закончить",
      questionOverview: "Все вопросы",
      swipeHint: "👈 Листайте пальцем влево-вправо 👉"
    },
    status: {
      answered: "Отвечен",
      notAnswered: "Пропущен",
      current: "Сейчас тут"
    }
  },

  results: {
    title: "ДЕМО ЗАВЕРШЕНО",
    congratulations: "Отлично!",
    percentage: "% набрано",
    complete: "КВИЗ ПРОЙДЕН",
    status: {
      passed: "Result",
      failed: "Result",
      retry: "ПОВТОР",
      pass: "Pass",
      study: "Not Pass"
    },
    performance: {
      genius: "Гений AI-тестирования",
      expert: "Эксперт AI-тестирования",
      pro: "Профи AI-тестирования",
      learner: "Изучающий AI-тестирование",
      beginner: "Новичок в AI-тестировании",
      // Full quiz performance levels
      master: "Мастер AI-тестирования",
      professional: "Профессионал AI-тестирования",
      candidate: "Кандидат в AI-тестировщики",
      // Perfect score level
      perfectMaster: "🎊 АБСОЛЮТНЫЙ МАСТЕР 🎊"
    },
    statistics: {
      correct: "Правильно",
      total: "Всего вопросов",
      bestStreak: "Лучшая серия",
      timeSpent: "Потрачено времени",
      questions: "вопросов",
      status: "Статус"
    },
    actions: {
      showReview: "Посмотреть разбор",
      hideReview: "Скрыть разбор",
      tryAgain: "Пройти демо заново",
      tryAgainNew: "Попробовать новые вопросы",
      shareResults: "Похвастаться результатом!",
      shareLinkedIn: "Поделиться в LinkedIn"
    },
    sharing: {
      title: "Похвастайтесь результатом! 🎉",
      description: "Покажите коллегам свои знания ИИ-тестирования!",
      hashtags: ["ISTQB", "AITesting", "Certification", "TechSkills", "QualityAssurance"],
      messages: {
        success: "🎉 Готово! LinkedIn открыт, результат скопирован!",
        clipboard: "🎉 Результат скопирован в буфер!",
        manual: "Скопируйте этот текст для публикации в LinkedIn:"
      },
      // Perfect score sharing
      perfectScore: {
        title: "🎊 ИДЕАЛЬНЫЙ РЕЗУЛЬТАТ! 🎊",
        description: "В посте есть секретный хештег для 30% скидки!",
        hashtag: "#ainastasiaquizwinner",
        discountOffer: "30% скидка на полный курс!",
        championText: "Теперь вы официальный чемпион ИИ-тестирования!",
        hiddenModeUnlocked: "🎉 ВАУ! ВЫ ОТКРЫЛИ СКРЫТЫЙ РЕЖИМ! 🎉",
        hiddenModeTitle: "СКРЫТЫЙ РЕЖИМ АКТИВИРОВАН!",
        russianCongratulations: "🎉 ВАУ! ВЫ ОТКРЫЛИ СКРЫТЫЙ РЕЖИМ! 🎉",
        perfectScoreMessage: "Вы ответили правильно на ВСЕ 40 вопросов и разблокировали секретный режим!",
        championOfferTitle: "🎁 СПЕЦИАЛЬНОЕ ПРЕДЛОЖЕНИЕ ДЛЯ ЧЕМПИОНА:",
        specialOffer: "КРУТОЕ ПРЕДЛОЖЕНИЕ: Поделитесь этим постом и напишите мне в соцсети со ссылкой на ваш пост — получите 30% скидку на полный курс!",
        contactInstructions: "Опубликуйте пост в LinkedIn с хештегом #ainastasiaquizwinner и напишите мне в соцсети со ссылкой на пост — получите 30% скидку на основной курс!",
        linkedinButtonHint: "💡 В кнопке 'Поделиться в LinkedIn' уже есть готовый текст с секретным хештегом"
      }
    },
    upgrade: {
      title: "Готовы к полной версии?",
      description: "Прокачайте знания AI-тестирования до профессионального уровня",
      features: [
        "300+ экспертных вопросов",
        "Все 11 глав",
        "тренировки с уникальными вопросами"
      ],
      button: "Хочу полную версию"
    },
    course: {
      title: "Курс теории AI-тестирования",
      subtitle: "📚 ПРОКАЧКА СКИЛОВ",
      description: "Хотите копнуть глубже? Присоединяйтесь к нашему теоретическому курсу для подготовки к ISTQB AI Tester.",
      features: [],
      button: "Забрать скидку",
      // Full quiz course promotion
      fullCourse: {
        nextLevel: "🎓 ВАС ЖДЁТ СЛЕДУЮЩИЙ УРОВЕНЬ 🎓",
        masterTitle: "Курс теории AI-тестирования",
        masterDescription: "Прокачайте знания AI-тестирования до профессионального уровня с нашим полным теоретическим курсом. Узнайте не только ЧТО тестировать, но и КАК тестировать AI-системы как настоящий профи!",
        bonusTitle: "🎁 БОНУС ДЛЯ УЧАСТНИКОВ КВИЗА 🎁",
        bonusDescription: "15% СКИДКА + эксклюзивные материалы",
        claimButton: "🔥 ЗАБРАТЬ БОНУС СЕЙЧАС 🔥"
      }
    },
    feedback: {
      title: "Есть идеи, как улучшить продукт?",
      button: "Оставить отзыв"
    },
    social: {
      title: "Подписывайтесь на AI.Nastasia! 🚀",
      description: "Присоединяйтесь к тусовке",
      platforms: {
        instagram: "Instagram",
        tiktok: "TikTok",
        linkedin: "LinkedIn",
        telegram: "Telegram"
      }
    }
  },

  review: {
    title: "Разбор ответов",
    yourAnswer: "Ваш ответ:",
    correctAnswer: "Правильный ответ:",
    explanation: "Объяснение:",
    notAnswered: "Пропущен"
  },

  languageSelector: {
    title: "Выберите язык",
    current: "Сейчас выбран",
    available: "Доступные языки",
    select: "Выбрать"
  },

  mobile: {
    pullToRefresh: "↓ Потяните вниз для обновления ↓",
    swipeInstructions: "👈 Листайте пальцем влево-вправо 👉",
    tapToSelect: "Нажмите, чтобы выбрать ответ",
    doubleTapToConfirm: "Двойной тап для подтверждения"
  },

  a11y: {
    languageSelector: "Выбор языка",
    questionProgress: "Вопрос {current} из {total}",
    optionSelected: "Выбран вариант {option}",
    timerWarning: "Время почти истекло",
    resultsSummary: "Квиз завершён с результатом {score}%"
  }
};